import { memo, useMemo } from "react"
import { treatmentStatusesOptions } from "../../../lib/systemData"
import { isLightColor } from "../../../lib/script"
import classes from './AICADepartmentsCell.module.css'
import BodySimpleModalV3 from "../../common/modal/BodySimpleModalV3"
import CheckboxCell from "../../common/interactive/CheckboxCell"
import WorkQDeferredCustomSelect from "./WorkQDeferredCustomSelect"
import { filterActions } from "../../../store/filter"
import { caseQuickUpdate } from "../../../lib/fetchApi"
import { notificationActions } from "../../../store/notifications"
import { useDispatch, useSelector } from "react-redux"
import { getDaysDifferenceSimple } from "../../../lib/dateScripts"
import { compareSpecialityValues } from "../../../lib/misc"

const EMPTY_OPTIONS = [];
const normalizeBkColorToken = (rawColor) => {
    if (!rawColor || typeof rawColor !== "string") {
        return null;
    }
    return rawColor.split(" ").join("_");
};

function AICADepartmentsCell({ specialityData, prefix, caseData, editable, workqSlug }) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)

    // const departmentId = specialityData ? specialityData[prefix + '_status']?.status : null
    const departmentId = specialityData ? specialityData[prefix + '_status'] : null
    const resolvedOptions = treatmentStatusesOptions();
    const options = resolvedOptions || EMPTY_OPTIONS;
    const dataObject = useMemo(() => {
        const next = {
            text: null,
            color: null,
            bkColor: null,
            textColor: null
        };
        if (!options) {
            return next;
        }
        const itemData = options.find(item => item.value == departmentId);
        if (!itemData) {
            return next;
        }
        next.text = itemData.label;
        if (itemData.color) {
            next.color = normalizeBkColorToken(itemData.color);
        }
        if (itemData.color_code) {
            next.bkColor = itemData.color_code;
            const lightDark = isLightColor(itemData.color_code);
            next.textColor = lightDark ? 'var(--text)' : 'var(--white)';
        }
        return next;
    }, [options, departmentId]);

    const updateHandler = async (data) => {
       
        let reqBody = {
            type: data.identifier.type,
            type_id: null,
            workq: workqSlug,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        let dispatchObj = {
            folder: data.identifier.folder,
            item: {
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    },
                ]            
            }
        }


        let update = await caseQuickUpdate(userToken, caseData.case.id, reqBody, null, true)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
            dispatch(notificationActions.setError({errorMessage: `Your changes have been successfully saved to the case.`, type: 'success'}))
            dispatch(filterActions.updateItemInWorkQRow(dispatchObj))
        }    
    }    


    if (editable) {
        return <div className={`${classes.cell_row} ${classes.cell_row_flex} ${classes.justify_centered}`}>
            {specialityData && <>
                <div>
                    {/* //FALLBACK TO N/A */}
                    <WorkQDeferredCustomSelect
                        preSelectedValue={specialityData[prefix + '_status'] || null}
                        getOptionsData={treatmentStatusesOptions}
                        action={updateHandler}
                        thin_select={true}
                        minWidth={120}
                        openOnShellClick={true}
                        fixedDrawer={true}
                        ignoreDeactivatedOptions={false}
                        undetermined={"N/A"}
                        identifier={{type: 'case_aica_department_status', field: prefix + '_status', type_id: null, folder: 'aica_department_status'}}
                    />
                    {specialityData[prefix + '_updated_at'] && <div className={`${classes.status_more}`} style={{marginTop: 2}}>Idle for {Math.abs(getDaysDifferenceSimple(specialityData[prefix + '_updated_at']))} days</div>}
                </div>
                {/* <div>
                    (0 / 0)
                    <div className={classes.aica_non_compliant}>
                        <BodySimpleModalV3 message={'Non-Compliant'}>
                            <div className={classes.aica_non_compliant_text}>N/C</div>
                        </BodySimpleModalV3>
                    </div>
                </div> */}
                <div>
                    {specialityData[prefix + '_kept'] || specialityData[prefix + '_missed'] ? <>
                        ( {specialityData[prefix + '_kept'] ? specialityData[prefix + '_kept'] : 0} / <span className={compareSpecialityValues(specialityData[prefix + '_kept'], specialityData[prefix + '_missed']) ? classes.status_more_missed : ''}>{specialityData[prefix + '_missed'] ? specialityData[prefix + '_missed'] : 0}</span> )
                    </> : null}
                    <div>
                        <CheckboxCell
                            action={updateHandler}
                            checked={specialityData[prefix + '_non_compliant']}
                            label={'N/C'}
                            setStyle={'box_small'}
                            direction={'reverse'}
                            identifier={{type: 'case_aica_department_status', field: prefix + '_non_compliant', type_id: null, folder: 'aica_department_status'}}
                        />
                    </div>
        
                </div>
            </>}
        </div>
    } 


    return <div style={{backgroundColor: dataObject.bkColor, color: dataObject.textColor}} className={`${classes.cell_row} ${classes.cell_row_flex} ${classes.justify_centered} ${dataObject.color ? 'bk_' + dataObject.color : ''}`}>
        {specialityData && <div className={classes.cell_row_content}>
            <div className={classes.cell_row_content_status_container}>
                <div className={classes.cell_row_content_status}>
                    {dataObject && dataObject.text ? dataObject.text : 'N/A'}
                </div>
                {specialityData[prefix + '_kept'] || specialityData[prefix + '_missed'] ? <>
                    ( {specialityData[prefix + '_kept'] ? specialityData[prefix + '_kept']  : 0} / <span className={compareSpecialityValues(specialityData[prefix + '_kept'], specialityData[prefix + '_missed']) ? classes.status_more_missed : ''}>{specialityData[prefix + '_missed'] ? specialityData[prefix + '_missed'] : 0}</span> )
                </> : null}
                {/* ( {specialityData[prefix + '_status']?.kept ? specialityData[prefix + '_status']?.kept  : 0} / {specialityData[prefix + '_status']?.missed ? specialityData[prefix + '_status']?.missed : 0} ) */}
            </div>
            {/* <div>Kept  - Missed</div> */}
            {/* <div className={classes.aica_kept_missed}>
                <span>{specialityData[prefix + '_status']?.kept ? specialityData[prefix + '_status']?.kept  : 0} Kept</span> - <span>{specialityData[prefix + '_status']?.missed ? specialityData[prefix + '_status']?.missed : 0} Missed</span>
            </div> */}
            {/* <div>
                <CheckboxCell checked={specialityData[prefix + '_status']?.non_compliant} label={'Non-Compliant'} isDisabled={true} setStyle={'box_small'} direction={'reverse'}/>
            </div> */}
            {specialityData[prefix + '_non_compliant'] ? <div className={classes.aica_non_compliant}>

                <BodySimpleModalV3 message={'Non-Compliant'}>
                    <div className={classes.aica_non_compliant_text}>N/C</div>
                </BodySimpleModalV3>
            </div> : null}
        </div>}
        
    </div>
}

function aicaDeptCellPropsEqual(prevProps, nextProps) {
    if (prevProps.prefix !== nextProps.prefix) return false;
    if (prevProps.editable !== nextProps.editable) return false;
    if (prevProps.workqSlug !== nextProps.workqSlug) return false;
    if (prevProps.caseData?.case?.id !== nextProps.caseData?.case?.id) return false;

    const prevData = prevProps.specialityData;
    const nextData = nextProps.specialityData;
    if (prevData === nextData) return true;
    if (!prevData || !nextData) return prevData === nextData;

    const p = nextProps.prefix;
    const keys = [
        `${p}_status`,
        `${p}_updated_at`,
        `${p}_kept`,
        `${p}_missed`,
        `${p}_non_compliant`,
    ];
    for (const key of keys) {
        if (prevData[key] !== nextData[key]) {
            return false;
        }
    }
    return true;
}

export default memo(AICADepartmentsCell, aicaDeptCellPropsEqual);
